import { MODAL_SIZE } from '@constants'
import cn from 'classnames'
import { useModal } from 'mmfintech-commons'
import { type ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import './ModalDialog.scss'

export type ModalSize = (typeof MODAL_SIZE)[keyof typeof MODAL_SIZE]

interface ModalDialogOptions {
  closeOnClickOutside?: boolean
  closeOnEscape?: boolean
  hideCloseIcon?: boolean
  scrollable?: boolean
  maxWidth?: number
  onClose?: () => void
  transparent?: boolean
  size: ModalSize
}

interface Props {
  content?: ReactNode
  options?: ModalDialogOptions
  visible: boolean
  onClose: () => void
}

function ModalDialog({ content, options, visible, onClose }: Props) {
  const { ref, modalOptions, handleMouseDown } = useModal({
    options,
    visible,
    onClose
  })

  const location = useLocation()

  useEffect(() => {
    if (visible) {
      typeof onClose === 'function' && onClose()
    }
    // eslint-disable-next-line
  }, [location.pathname])

  if (!visible) {
    return null
  }

  return (
    <div className='modal-wrapper' onMouseDown={handleMouseDown} ref={ref}>
      <div
        className={cn('modal-container', {
          'size-auto': modalOptions.size === MODAL_SIZE.AUTO,
          'size-large': modalOptions.size === MODAL_SIZE.LARGE,
          'size-small': modalOptions.size === MODAL_SIZE.SMALL,
          'size-extra-large': modalOptions.size === MODAL_SIZE.EXTRA_LARGE,
          centered: modalOptions.size === MODAL_SIZE.CENTERED,
          horizontal: modalOptions.size === MODAL_SIZE.HORIZONTAL,
          transparent: modalOptions.transparent === true,
          'overflow-none': modalOptions.overflow === 'none'
        })}
        data-test='modal-container'
        onMouseDown={e => e.stopPropagation()}
      >
        {content}
      </div>
    </div>
  )
}

export default ModalDialog
